var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"ib"},[_c('el-aside',{attrs:{"width":"auto"}},[_c('ib-menu')],1),_c('div',{staticStyle:{"width":"100%","overflow":"auto"}},[_c('bread-crumb'),_c('el-main',{staticClass:"main-cnt home-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }